import { Link } from 'react-router-dom'
import { FloatingVoiceControls } from './FloatingVoiceControls'
import { ConnectionStatus, VoiceStatus } from '../hooks/usePeerJS'
import '../styles/GameHeader.css'

interface Player {
  number: number
  name: string
  avatar?: string
  isConnected?: boolean
}

interface GameHeaderProps {
  gameTitle: string
  gameIcon?: string
  players: Player[]
  sessionCode?: string
  showBackButton?: boolean
  // Voice chat controls (optional - only for network games)
  voiceControls?: {
    connectionStatus: ConnectionStatus
    voiceStatus: VoiceStatus
    onToggleMute: () => void
    onConnect?: () => void
    onDisconnect?: () => void
  }
}

export function GameHeader({
  gameTitle,
  gameIcon,
  players,
  sessionCode,
  showBackButton = true,
  voiceControls
}: GameHeaderProps) {
  return (
    <>
      <header className="game-header">
        {/* Left Section: Title */}
        <div className="game-header-left">
          {showBackButton && (
            <Link to="/" className="game-header-back" title="Back to home">
              ←
            </Link>
          )}
          {gameIcon && <span className="game-header-icon">{gameIcon}</span>}
          <h1 className="game-header-title">{gameTitle}</h1>
        </div>

        {/* Center Section: Players */}
        <div className="game-header-center">
          {players.map((player) => (
            <div
              key={player.number}
              className={`game-header-player ${player.isConnected === false ? 'disconnected' : ''}`}
              title={player.name}
            >
              {player.avatar ? (
                <div className="player-avatar">{player.avatar}</div>
              ) : (
                <div className="player-avatar player-placeholder">
                  P{player.number}
                </div>
              )}
              <span className="player-name">{player.name}</span>
              {player.isConnected === false && (
                <span className="player-status-dot offline" />
              )}
            </div>
          ))}
        </div>

        {/* Right Section: Controls */}
        <div className="game-header-right">
          {sessionCode && (
            <div className="session-code-compact" title="Session code">
              <span className="session-code-label">Code:</span>
              <span className="session-code-value">{sessionCode}</span>
            </div>
          )}
        </div>
      </header>

      {/* Floating Voice Controls (if provided) */}
      {voiceControls && (
        <FloatingVoiceControls
          connectionStatus={voiceControls.connectionStatus}
          voiceStatus={voiceControls.voiceStatus}
          onToggleMute={voiceControls.onToggleMute}
          onConnect={voiceControls.onConnect}
          onDisconnect={voiceControls.onDisconnect}
        />
      )}
    </>
  )
}
